export var ESearchBoxType;
(function (ESearchBoxType) {
    ESearchBoxType["Field"] = "field";
    ESearchBoxType["Search"] = "search";
    ESearchBoxType["Navigation"] = "navigation";
})(ESearchBoxType || (ESearchBoxType = {}));
